export default "__VITE_ASSET__CP09oXn4__"